import React, {useState, useEffect} from "react";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";

import * as yup from 'yup';

import {API_ENDPOINT, APP_URL, APP_NAME, admin_phone, toast_anim, addDays} from '../config/Common'
import ScrollPageTop from '../../routes/ScrollPageTop'
import {Links} from '../../routes/PathLink'
import Seo from '../seo/seo'
import Input from '../../ui/input.jsx'
import TextArea from '../../ui/text-area.tsx'
import Button from '../../ui/Button.tsx'
import Label from '../../ui/label.tsx'
import DatepickerInput from '../../ui/datepicker-input.jsx'

import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import {useAuth} from '../../provider/AuthProvider'
import {
   Control,
   FieldErrors,
   useForm,
   useFormState,
   useWatch,
   Controller
} from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import moment from 'moment';
import PhoneInput from 'react-phone-input-2'

const formSchema = yup.object().shape({
   name: yup.string().required('Name is required'), 
   email: yup.string().required('Email is required'), 
   phone: yup.string().required('Phone number is required'), 
   appointment_date:yup.date().required('You must schedule your appointment.'),
   package_id:yup.string().required('Please select a package.'),
   
})
let defaultValues = {  
   name: '',
   email:'',
   phone:''
};

const DietNutrition = (props) => {

   const [loading, setLoading] = useState(false)
   const { register, handleSubmit , control, reset, setValue, setError, formState: { errors },} = useForm({
      defaultValues: defaultValues,
      resolver: yupResolver(formSchema),
   });

   const { isUser, myInfo } = useAuth();
   const [pagecontent, setPagecontent] = useState(null);
   const [pagetitle, setPageTitle] = useState(null);
   const [packageList, setPackageList] = useState(null);
   const [startDate, setStartDate] = useState(null);
   const [activePackage, setActivePackage] = useState(false);
   const [formSubmint, setFormSubmit] = useState(false);

   useEffect(() => {
      getPageDetails()
      let date = addDays(new Date(), 1);
      setStartDate(date)
      setValue('appointment_date', moment(date).format(), true);
      //console.log('myInfo===', myInfo)
   },[]);

   useEffect(() => {
      
         defaultValues = {  
            name: myInfo ? myInfo.name : '',
            email:myInfo ? myInfo.email :'',
            phone:myInfo ? myInfo.phone_no.length < 12 ? `91${myInfo.phone_no}` : myInfo.phone_no : ''
         };
   
        
         reset(defaultValues)
      },[])

    const getPageDetails = () => {
      //setLoading(true)
      fetch(`${API_ENDPOINT}/get_diet_packages`,{
         method: 'GET',
         headers : {        
            'Content-Type': 'application/json',
            'Accept': 'application/json', 
         }
      }).then(function (response) {
            return response.json();
      }).then( (result)=> {
         console.log('package======',result)
         //setLoading(false)
         setPackageList(result?.data);
         //setPageTitle(result?.data?.title);
         //setMetaTitle(result.data.meta_title ? result.data.meta_title : result.data.title)
         //setMetaDesc(result.data.meta_description ? result.data.meta_description : result.data.content)
      })
   }

   const onSubmit = (values) => {
      //console.log('diet form===', values)
      setLoading(true)
      fetch(`${API_ENDPOINT}/send_diet_package_request`,{
			method: 'POST',
			headers : {        
				'Content-Type': 'application/json',
				'Accept': 'application/json', 
			},
         body: JSON.stringify(values)
		}).then(function (response) {
				return response.json();
		}).then( (result)=> {
			console.log('mail======',result)
			
         setLoading(false)
         if(result.status === 1){
            setFormSubmit(true)
            defaultValues = {  
               name: '',
               email:'',
               phone:''
            };
            reset(defaultValues)	
            toast_anim('Mail sent')		
            window.scrollTo({
               top: 0,
               left: 0,
               behavior: "smooth", // change to "smooth" if you want animation
            });
         }
         if(result.status === 0){
            setError('name', { type: 'manual', message: result?.message?.name });
            setError('email', { type: 'manual', message: result?.message?.email });
            setError('phone', { type: 'manual', message: result?.message?.phone });
            setError('appointment_date', { type: 'manual', message: result?.message?.appointment_date });
            setError('package_id', { type: 'manual', message: result?.message?.package_id });
         }
		})
   }

   const handleDate = (date) => {
         //console.log(date)
         setStartDate(date)
         setValue('appointment_date', moment(date).format(), true);
      }

   return(
      <ScrollPageTop>
      <Seo 
         title={`CTMRIHUB Diet & Nutrition - ${APP_NAME}`}
         desc="CTMRIHUB Diet & Nutrition connects you with qualified professionals for personalized guidance based on your lifestyle, food preferences, and health goals."
         url={`${APP_URL}${Links.DIET_NUTRITION}`}
         image={`./img/home-bg.jpg`}
      />
      <Header />
      <div className="w-full bg-gray-100">
         <div className="mx-auto flex w-full max-w-7xl flex-col py-10 px-5 md:flex-row xl:py-14 xl:px-8 2xl:px-14">
            <div className="order-1 w-full shrink-0 bg-light p-5 md:order-1 md:w-[45%] lg:w-[45%]">
               <h1 className="mb-7 font-body text-xl font-bold text-heading md:text-2xl">
               CTMRIHUB Diet & Nutrition
               </h1>
               <p class="mb-2">Eat Better. Feel Better. Live Healthier.</p>
               <p class="mb-3">Your nutrition needs are unique. CTMRIHUB Diet & Nutrition connects you with qualified professionals for personalized guidance based on your lifestyle, food preferences, and health goals.</p>
               <h3 class="text-xl mb-3">Our Services</h3>
               <ul class="list-disc list-inside mb-5">
                  <li>Weight Management: Sustainable nutrition guidance for weight-related goals.</li>
                  <li>Everyday Healthy Eating: Balanced meal planning for daily life.</li>
                  <li>Diabetes Nutrition Support: Guidance alongside your existing medical care.</li>
                  <li>Personalized Meal Planning: Practical meal plans suited to your preferences and routine.</li>
                  <li>Follow-up Consultations: Ongoing progress reviews and plan adjustments.</li>
               </ul>
               <h3 class="text-xl mb-3">How It Works</h3>
               <ul class="list-disc list-inside mb-5">
                  <li>Choose the service that suits your needs.</li>
                  <li>Request an appointment online.</li>
                  <li>Consult with a qualified nutrition professional.</li>
                  <li>Receive personalized nutrition guidance.</li>
                  <li>Schedule follow-up sessions as needed.</li>
               </ul>
               <h3 class="text-xl mb-3">Ready to Get Started?</h3>
               <p class="mb-2">Take the first step toward making informed food choices: Book a Nutrition Consultation.</p>
               <p class="mb-5"><strong>Disclaimer:</strong> Nutrition services support general health and do not replace medical diagnosis, treatment, or emergency care. Services are provided by appropriately qualified professionals.</p>
            </div>
            <div className="order-2 mb-8 w-full bg-light p-5 md:order-2 md:mb-0 md:p-8 ltr:md:ml-7 rtl:md:mr-7 ltr:lg:ml-9 rtl:lg:mr-9">
               
               
               
               <h3 class="text-xl mb-3">Request an appointment</h3>
               {formSubmint ? 
                  <div className="p-5 bg-green-100 border border-green-400 rounded-md flex flex-col justify-center items-center">
                     <p className="my-2 text-md text-start text-green-500">Your request has been submitted successfully.</p>
                     <p className="my-2 text-md text-start text-green-500">Our team will contact you soon.</p>
                  </div>
               :
               <form onSubmit={handleSubmit(onSubmit)}>
                  {errors.package_id?.message && <p className="my-2 text-md text-start text-red-500">{errors.package_id?.message}</p>}

                  <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                     {packageList && packageList.length > 0 && packageList.map((item, index) => (
                        <div key={index} className={`border p-3 rounded-md hover:shadow-md transition-shadow duration-300 cursor-pointer hover:bg-accent hover:text-light` + (activePackage === item.id ? ' bg-accent text-light' : '')} onClick={() => {setActivePackage(item.id)
                           setValue('package_id', item.id, true);
                        }}>
                           <h4 className="font-semibold text-lg mb-2">{item.package_name}</h4>
                           <p className="text-sm mb-2">{item.description}</p>
                           <p className="text-sm font-semibold">Price Range: ₹{item.fromPrice}{item.toPrice ? ` - ₹${item.toPrice}`:'+' }</p>
                        </div>
                     ))}
                     <input type="hidden" {...register('package_id')} />
                  </div>
                  
                  <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 mt-5">
                     <Input                
                        label={`Name`}
                        {...register('name')}                     
                        variant="outline"
                        className="mb-5"
                        error={errors.name?.message}
                        required
                     />
                     <Input                
                        label={`Email`}
                        {...register('email')}                     
                        variant="outline"
                        className="mb-5"
                        error={errors.email?.message}
                        type="email"
                        required
                     />
                     <Input                
                        label={`Phone`}
                        {...register('phone')}                     
                        variant="outline"
                        className="mb-5"
                        error={errors.phone?.message}
                        required
                     />
                     <div className="mb-5">
                           <Label>Schedule Appointment <span className="text-red-500"> *</span></Label>
                           <DatePicker
                              {...register('appointment_date')}
                              name="appointment_date"
                              selected={startDate}
                              onChange={handleDate}
                              timeInputLabel="Time:"
                              dateFormat="d MMMM, yyyy h:mm aa"
                              showTimeInput
                              customInput={<DatepickerInput />}
                           />
                           {errors.appointment_date?.message && <p className="my-2 text-xs text-start text-red-500">{errors.appointment_date?.message}</p>}
                        </div>
                     
                  </div>
                     <TextArea
                        label={`Message (Optional)`}
                        {...register('message')}                     
                        variant="outline"
                        className="mb-5"
                        error={errors.message?.message}
                     />
                  
                  
                  <Button loading={loading}>
                     Submit
                  </Button>
                  
               </form>
            }
               
            </div>
         </div>
      </div>
      
      <Footer />
      </ScrollPageTop>
   )
}

export default DietNutrition;